<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardDelivery.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <delivery-filters
      options="delivery"
    />
    <orders
      options="delivery"
    />
  </section>
</template>

<script>
import DeliveryFilters from '@/components/filters/DeliveryFilters'
import Orders from '@/components/dashboard/Orders'

export default {
  name: 'DashboardDelivery',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  components: {
    DeliveryFilters,
    Orders
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardDelivery.vue